import { Helmet } from 'react-helmet-async';

const siteOrigin = 'https://www.leiongroup.com';
const siteName = 'LEION Engineering';
const socialImage = `${siteOrigin}/assets/product-logo-pitless-weighbridge.png`;

const Seo = ({ title, description, path, noindex = false }) => {
  const normalizedPath = path === '/' ? '/' : `/${path.replace(/^\/+|\/+$/g, '')}`;
  const canonicalUrl = `${siteOrigin}${normalizedPath}`;

  return (
    <Helmet>
      <html lang="en" />
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="robots" content={noindex ? 'noindex, nofollow' : 'index, follow'} />
      <link rel="canonical" href={canonicalUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={siteName} />
      <meta property="og:image" content={socialImage} />
      <meta property="og:image:alt" content="LEION Engineering industrial weighbridge installation" />
      <meta property="og:locale" content="en_US" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={socialImage} />
    </Helmet>
  );
};

export default Seo;
